var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBills(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "93px",
    height: "92px",
    viewBox: "0 0 93 92",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Asset-Artboard-Page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustrative-/-Bills",
    transform: "translate(0.692308, 0.000000)",
    stroke: "#000000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3533468,70.4697705 L15.0942531,70.108958 L19.403878,7.18742803 L68.3435646,10.539678 L67.9432208,16.3737716 M27.926887,21.7432655 L28.4803245,13.6702655 L77.4185757,17.0225155 L73.1089506,79.9447656 L69.4239193,79.6924843 M20.3535624,84.8125007 L69.4068132,84.8125007 L69.4068132,21.7429065 L20.3535624,21.7429065 L20.3535624,84.8125007 Z M28.0230561,63.8999682 L61.7367423,63.8999682 M28.0230561,70.143385 L61.7367423,70.143385 M28.0230561,76.3861602 L61.7367423,76.3861602 M45.4730854,29.2756941 L45.4730854,32.8924441 M50.9942354,39.0206503 C50.9942354,39.0206503 51.7129854,32.8925878 45.4727979,32.8925878 C39.8176729,32.8925878 39.8334849,37.8469316 39.8334849,37.8469316 C39.8334849,37.8469316 39.8176729,42.9536504 45.4188917,42.9536504 M39.8431167,46.8872259 C39.8431167,46.8872259 39.1250854,53.0145697 45.3645543,53.0145697 C51.0196795,53.0145697 51.0038675,48.0609446 51.0038675,48.0609446 C51.0038675,48.0609446 51.0196795,42.9535071 45.4191793,42.9535071 M45.4730854,53.0148569 L45.4730854,56.631607",
    id: "Icon"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBills);
export default __webpack_public_path__ + "static/media/bills.71298b90.svg";
export { ForwardRef as ReactComponent };